import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import EventDetails from "./Components/EventDetails/EventDetails";
import Header from "./Common/Header/Header";
import Footer from "./Common/Footer/Footer";
import Event from "./Components/Event/Event";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import EmailPage from "./Components/emailPage/EmailPage";
import { useEffect, useState } from "react";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="loader-container">
          <img src="..\Move-Favicon.png" width={50} height={50} />
        </div>
      ) : (
        <>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/:slug" element={<EventDetails />} />
            <Route path="/events" element={<Event />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/email" element={<EmailPage />} />
          </Routes>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
